// extracted by mini-css-extract-plugin
export default {"socialBlock":"_1WlX8","iconMenuList":"_19KNQ","iconItemLink":"_1G-OF"};